import React from 'react';
import { GuestTextComponentFragment } from '@graphql/generated';

interface RichTextProps {
  richTextComponentData: GuestTextComponentFragment;
}

export const RichText: React.FC<RichTextProps> = () => {
  return <></>;
};
